import { isNil } from 'lodash'

import { queryPricingMethodApi } from '@eastcoal/api/trade/pricingMethod/queryPricingMethod'
import { savePricingMethodApi } from '@eastcoal/api/trade/pricingMethod/savePricingMethod'
import { updatePricingMethodApi } from '@eastcoal/api/trade/pricingMethod/updatePricingMethod'

import { PageContainer } from '@eastcoal/common/components/Layout/PageContainer'

import { CrudForm } from '@eastcoal/formily/components/CrudForm'
import { BackButton } from '@eastcoal/formily/components/CrudForm/shared/BackButton'
import { SaveButton } from '@eastcoal/formily/components/CrudForm/shared/SaveButton'
import { FormItem } from '@eastcoal/formily/components/FormItem'
import { Input } from '@eastcoal/formily/components/Input'
import { Select } from '@eastcoal/formily/components/Select'

import { useNavigate } from '@eastcoal/router/exports/react-router'

import {
  PricingFormData,
  PricingFormExposedProps,
  PricingFormProps
} from './interface'

const schema: PricingFormProps['schema'] = [
  {
    name: 'name',
    title: '名称',
    type: 'string',
    required: true,
    'x-component': Input,
    'x-decorator': FormItem
  },
  {
    name: 'supportTradeType',
    title: '业务类型',
    type: 'array',
    required: true,
    'x-component': Select,
    'x-component-props': {
      mode: 'multiple'
    },
    'x-decorator': FormItem,
    enum: [
      {
        value: '0',
        label: '竞价'
      },
      {
        value: '1',
        label: '挂牌'
      }
    ]
  },
  {
    name: 'unit',
    title: '数量单位',
    type: 'string',
    required: true,
    'x-component': Input,
    'x-decorator': FormItem
  },
  {
    name: 'priceUnit',
    title: '价格单位',
    type: 'string',
    required: true,
    'x-component': Input,
    'x-decorator': FormItem
  },
  {
    name: 'strategy',
    title: '计算策略',
    type: 'string',
    required: true,
    'x-component': Input,
    'x-decorator': FormItem
  },
  {
    name: 'checkStrategy',
    title: '校验策略',
    type: 'string',
    required: true,
    'x-component': Input,
    'x-decorator': FormItem
  }
]

const readApi: PricingFormProps['readApi'] = ({ id }) => {
  return {
    api: async () => {
      const detail = await queryPricingMethodApi({ id })
      return {
        ...detail,
        supportTradeType: detail.supportTradeType
          ? detail.supportTradeType.split(',')
          : []
      } as PricingFormData
    },
    ready: !isNil(id),
    refreshDeps: [id]
  }
}

const createApi: PricingFormProps['createApi'] = formData => {
  return savePricingMethodApi({
    ...formData,
    supportTradeType: formData.supportTradeType?.join()
  })
}

const updateApi: PricingFormProps['createApi'] = formData => {
  return updatePricingMethodApi({
    ...formData,
    supportTradeType: formData.supportTradeType?.join()
  })
}

export const PricingForm = ({ mode }: PricingFormExposedProps) => {
  const navigator = useNavigate()
  return (
    <PageContainer>
      <CrudForm
        createApi={createApi}
        mode={mode}
        name='pricingForm'
        readApi={readApi}
        schema={schema}
        updateApi={updateApi}
        actions={[
          <BackButton key='backButton' />,
          <SaveButton key='saveButton' />
        ]}
        layout={{
          wrapperWidth: 400
        }}
        onSuccess={() => navigator(-1)}
      />
    </PageContainer>
  )
}
